import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { order_actions } from "../../../redux-store";
import { useHistory } from "react-router-dom";
import AddNewAddress from "./AddNewAddress";
import { toast } from "react-toastify";
import backend from "../../../api";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      "::placeholder": {
        color: "#aab7b8",
      },
    },
    invalid: {
      color: "#e54242",
    },
  },
};

const BillingDetails = ({ calculations }) => {
  const { user } = useSelector((state) => state.auth);
  const { items: cart = [], total_price } = useSelector((state) => state.cart);
  const loading = useSelector((state) => state.global.loading);
  const [selectedAddress, setSelectedAddress] = useState(
    user?.addresses?.[0]?._id || ""
  );
  const { register, handleSubmit, errors, setError, clearErrors } = useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const stripe = useStripe();
  const elements = useElements();

  const handleAddressChange = (e) => {
    setSelectedAddress(e.target.value);
  };

  const handleCardChange = (event) => {
    const { complete, empty, error } = event;
    if (complete) {
      clearErrors("cardNumber");
    }
  };

  const onSubmit = async (data) => {
    const exceededProduct = cart.find(
      (item) => item.quantity > item.product.stock_quantity
    );

    if (exceededProduct) {
      const message = `Product ${exceededProduct.product.product_name} exceeds available stock. Available quantity: ${exceededProduct.product.stock_quantity}`;
      toast.error(message);
      return;
    }

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        email: user?.user?.email,
      },
    });

    if (error) {
      console.error("Error:", error);
      setError("cardNumber", {
        type: "manual",
        message: error.message,
      });
      return;
    }

    clearErrors("cardNumber");

    const address = user?.addresses?.find((ua) => ua?._id === data?.address);

    const payload = {
      payment: {
        calculations,
        paymentMethod: paymentMethod?.id,
        receipt_email: user?.user?.email,
      },
      address: {
        ...address,
        country: address?.country?.country_name,
        city: address?.city?.city_name,
      },
      billing_details: {
        payment_type: "online",
      },
      customer: user?._id,
      status: {
        checked_out: {
          message: data?.checkoutNotes || "",
          date: new Date(),
        },
      },
    };

    if (!data?.checkoutNotes) {
      delete payload?.status?.checked_out?.message;
    }

    dispatch(order_actions.create_order(payload, history));
  };

  return (
    <>
      <h3>Customer Details</h3>
      <hr />
      <div className="d-flex flex-column">
        <p>
          <strong>Name:</strong>{" "}
          {`${user?.user?.first_name} ${user?.user?.last_name}`}
        </p>
        <p>
          <strong>Email:</strong> {user?.user?.email}
        </p>
        <p>
          <strong>Phone:</strong> {user?.user?.phone}
        </p>
        <p>
          <strong>Eksplode Code:</strong> {user?.user?.eksplode_code}
        </p>
      </div>

      <h3 className="mt-5">Billing Details</h3>
      <hr />
      <div className="d-flex align-items-center justify-content-between mb-3">
        <label htmlFor="address" className="mb-0">
          Shipping Address
        </label>
        <AddNewAddress />
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="field-group mb-3">
          <select
            name="address"
            value={selectedAddress}
            onChange={handleAddressChange}
            ref={register({
              required: {
                value: true,
                message: "Please select a shipping address",
              },
            })}
          >
            {user &&
              user.addresses?.map((ua) => (
                <option value={ua._id} key={ua._id}>
                  {`${ua.name}, ${ua.city.city_name}, ${ua.state}, ${ua.country.country_name} - ${ua.zip}`}
                </option>
              ))}
          </select>
          <div className="error">
            {errors.address && errors.address.message}
          </div>
        </div>

        <div className="field-group mb-3">
          <label htmlFor="cardNumber">Card Number</label>
          <CardElement
            id="cardDetails"
            options={cardElementOptions}
            onChange={handleCardChange}
          />
          <div className="error">
            {errors.cardNumber && errors.cardNumber.message}
          </div>
        </div>

        <div className="field-group mb-3">
          <label htmlFor="checkoutNotes">
            Checkout Notes{" "}
            <span style={{ fontWeight: "normal" }}>(optional)</span>
          </label>
          <textarea
            type="text"
            name="checkoutNotes"
            ref={register()}
            placeholder="Please provide further info for the order"
          />
          <div className="error">
            {errors.checkoutNotes && errors.checkoutNotes.message}
          </div>
        </div>

        <div className="field-group text-right">
          <button type="submit" className="btn btn-solid" disabled={loading}>
            {loading ? " Placing Order..." : " Place Order"}
          </button>
        </div>
      </form>
    </>
  );
};

export default BillingDetails;
